export const ErrorTag = ({ text }) => {
    return (
        <div className="bg-color-red-10 px-2 py-1 rounded-lg">
            <small className="text-color-red-100 text-center text-base">{text}</small>
        </div>
    );
};
